"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var delete_confirm_dialog_1 = require("../controls/delete-confirm-dialog");
var header_item_model_1 = require("./header-item.model");
var lodash_1 = require("lodash");
var immutable_1 = require("immutable");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var ColumnAlignmentType;
(function (ColumnAlignmentType) {
    ColumnAlignmentType["LEFT"] = "left";
    ColumnAlignmentType["CENTER"] = "center";
    ColumnAlignmentType["RIGHT"] = "right";
})(ColumnAlignmentType = exports.ColumnAlignmentType || (exports.ColumnAlignmentType = {}));
var BaseTable = /** @class */ (function () {
    function BaseTable() {
        this.destroySubject$ = new Subject_1.Subject();
        this._isReady = false;
        this._alignments = immutable_1.Map();
    }
    BaseTable.generateColumnAlignmentClasses = function () {
        return immutable_1.fromJS((_a = {},
            _a[ColumnAlignmentType.LEFT] = 'sis-popup-table__column--align-left',
            _a[ColumnAlignmentType.CENTER] = 'sis-popup-table__column--align-center',
            _a[ColumnAlignmentType.RIGHT] = 'sis-popup-table__column--align-right',
            _a));
        var _a;
    };
    Object.defineProperty(BaseTable.prototype, "rowToRemove", {
        get: function () {
            return this._rowToRemove;
        },
        set: function (value) {
            this._rowToRemove = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "currentLanguage", {
        get: function () {
            return this._currentLanguage;
        },
        set: function (value) {
            this._currentLanguage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "localeInfo", {
        get: function () {
            return this._localeInfo;
        },
        set: function (value) {
            this._localeInfo = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        set: function (value) {
            this._isReady = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "columnMetaFields", {
        get: function () {
            return this._columnMetaFields;
        },
        set: function (value) {
            this._columnMetaFields = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "headers", {
        get: function () {
            return this._headers;
        },
        set: function (value) {
            this._headers = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseTable.prototype, "alignments", {
        get: function () {
            return this._alignments;
        },
        set: function (value) {
            this._alignments = value;
        },
        enumerable: true,
        configurable: true
    });
    BaseTable.prototype.removeAction = function () {
        var index = this.rowItems.indexOf(this._rowToRemove);
        if (index > -1) {
            this.rowItems.splice(index, 1);
        }
    };
    BaseTable.prototype.ngOnDestroy = function () {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    };
    BaseTable.prototype.isThereTableHeader = function () {
        return !!this.headers && this.headers.length !== 0;
    };
    BaseTable.prototype.isEmpty = function () {
        return !this.rowItems || this.rowItems.length === 0;
    };
    BaseTable.prototype.isNumeric = function (metaField) {
        return (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER ||
            metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL ||
            metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.DECIMAL);
    };
    BaseTable.prototype.onRemove = function (row) {
        var _this = this;
        this._rowToRemove = row;
        var dialogRef = this.dialog.open(delete_confirm_dialog_1.DeleteConfirmDialogComponent, {
            disableClose: true,
            autoFocus: false,
            width: '400px',
            height: 'auto',
        });
        dialogRef
            .afterClosed()
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (result) {
            if (result) {
                _this.removeAction();
            }
        }, function (err) { return console.error(err); });
    };
    BaseTable.prototype.isWithPopup = function () {
        return !!this.subFormKey;
    };
    BaseTable.prototype.getUniqueIdForSubEntity = function () {
        var subEntityIds = this.rowItems.map(function (subEntity) {
            return subEntity.getId();
        });
        var subEntityIdMinValue = this.rowItems.length > 0 ? Math.min.apply(Math, subEntityIds) : 0;
        return subEntityIdMinValue > 0 ? -1 : subEntityIdMinValue - 1;
    };
    BaseTable.prototype.handleHeader = function (requiredMetaFieldIds) {
        if (this.columnMetaFields) {
            this._headers = this.columnMetaFields.reduce(function (acc, metaField) {
                return acc.concat(new header_item_model_1.HeaderItem(metaField.getDisplayNameMsgId(), requiredMetaFieldIds.some(function (requiredMetaField) {
                    return requiredMetaField.getSystemName() ===
                        metaField.getSystemName();
                }), metaField.getDisplayNameMultilingual()));
            }, []);
        }
    };
    BaseTable.prototype.handleAlignments = function (col, mappings) {
        if (mappings && Object.keys(mappings).length > 0) {
            this._alignments = this._alignments.withMutations(function (mutable) {
                lodash_1.entries(mappings).forEach(function (_a) {
                    var key = _a[0], value = _a[1];
                    if (col.getSystemName() === key) {
                        mutable.set(key, BaseTable.columnAlignmentClasses.get(value.toString().toLocaleLowerCase(), ''));
                    }
                });
            });
        }
    };
    BaseTable.columnAlignmentClasses = BaseTable.generateColumnAlignmentClasses();
    return BaseTable;
}());
exports.BaseTable = BaseTable;
//# sourceMappingURL=base.table.js.map